import { TEAM_CATEGORIES } from 'cpool-constants';
import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

export const teamName = z.string().trim().min(1).max(100);
// null: the team carries no category, only teams of internal divisions may have one
export const teamCategory = z.nativeEnum(TEAM_CATEGORIES).nullable();
// team category per user id (only users whose team carries a category)
export const schemaUserCategories = z.record(schemaId, teamCategory.unwrap());
